import React, { useState } from 'react'
import styled from 'styled-components'
import { Flex } from 'reflexbox/styled-components'

import baseTheme from 'theme'

import Brand from '@anvilco-pkg/ui/components/Brand'
import UniversalLink from 'components/UniversalLink'
import Button from 'components/Button'
import { ButtonContainer } from 'components/Hero'

import { BACKGROUND_COLOR } from 'styles/GlobalStyle'
import { MOBILE_NAV_BAR_HEIGHT } from 'consts'

import IconNavMenu from '@anvilco-pkg/ui/components/Icon/IconNavMenu'
import IconClose from '@anvilco-pkg/ui/components/Icon/IconClose'
import IconChevronRight from '@anvilco-pkg/ui/components/Icon/IconChevronRight'
import IconChevronDown from '@anvilco-pkg/ui/components/Icon/IconChevronDown'

const NavbarContainer = styled(Flex).attrs({
  alignItems: ['center'],
  justifyContent: ['space-between'],
})`
  height: ${MOBILE_NAV_BAR_HEIGHT}px;
  background-color: ${BACKGROUND_COLOR};
  color: white;
  position: sticky;
  top: 0;
  z-index: 99;
  width: 100%;
`
const ToggleButtonContainer = styled(Flex).attrs({
  alignItems: ['center'],
  flexDirection: ['row'],
})`
  min-height: ${MOBILE_NAV_BAR_HEIGHT}px;
  flex-shrink: 0;
  padding-left: 20px;
  padding-right: 30px;
`
const NavbarLinkStyled = styled(UniversalLink)`
  padding: 0px;
`
const NavbarLeftButtons = styled(Flex).attrs({
  alignItems: ['center'],
})`
  gap: 17px;
  cursor: pointer;
  padding-left: 30px;
  padding-right: 30px;
`
const MenuItemContainer = styled(Flex).attrs({
  alignItems: ['flex-start'],
  flexDirection: ['column'],
})`
  position: absolute;
  top: ${MOBILE_NAV_BAR_HEIGHT}px;
  left: 0;
  background-color: ${BACKGROUND_COLOR};
  width: 100%;
  padding: 0px 20px;
  box-sizing: border-box;
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  overflow-y: auto;
  max-height: calc(100vh - ${MOBILE_NAV_BAR_HEIGHT}px);
`
const MenuItem = styled(Flex).attrs({
  alignItems: ['center'],
  justifyContent: ['space-between'],
})`
  color: ${baseTheme.colors.black};
  width: 100%;
  cursor: pointer;
  font-weight: ${baseTheme.fontWeights.bold};
  padding: 10px 0px;
`
const MenuItemWrapper = styled(Flex).attrs({
  alignItems: ['center'],
  justifyContent: ['space-between'],
  flexDirection: ['column'],
})`
  color: ${baseTheme.colors.black};
  width: 100%;
  border-bottom: 1px solid ${baseTheme.colors.blacks[10]};
  cursor: pointer;
  font-weight: ${baseTheme.fontWeights.bold};
`

const SubMenuContainer = styled.div`
  flex-direction: column;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 1;
`
const SubMenuItem = styled.div`
  color: black;
  cursor: pointer;
`
const SubmenuDesc = styled.div`
  text-align: start;
  font-size: ${baseTheme.fontSizes[30]}px;
  color: ${baseTheme.colors.black};
  text-decoration: none;
  font-weight: ${baseTheme.fontWeights.thin};
`
const SubmenuInfo = styled(Flex).attrs({
  alignItems: ['start'],
  justifyContent: ['start'],
  flexDirection: ['column'],
})`
  align-items: start;
  color: ${baseTheme.colors.black};
  text-decoration: none;
  font-size: ${baseTheme.fontSizes[40]}px;
`
const IconWrapper = styled(Flex).attrs({
  alignItems: ['center'],
  justifyContent: ['center'],
})`
  width: 38px;
  height: 38px;
  background-color: ${(props) =>
    props.bg ? props.bg : baseTheme.colors.blacks[10]};
  border-radius: 100px;
`
const BaseSubmenuCard = styled(UniversalLink).withConfig({
  shouldForwardProp: (prop) => ['height', 'gap'].indexOf(prop) === -1,
})`
  height: ${({ height }) => height}px;
  display: flex;
  gap: ${({ gap }) => gap}px;
  flex-direction: row;
  align-items: center;
  cursor: default;
  &:hover {
    background-color: ${baseTheme.colors.white};
    box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
  }
`

const SubmenuCard = styled(BaseSubmenuCard)`
  height: 60px;
  gap: 9px;
`

const BaseButtonContainer = styled(ButtonContainer)`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`
const HeroButtonContainer = styled(BaseButtonContainer)``

const ClickableMenu = styled(UniversalLink)`
  color: ${baseTheme.colors.black};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-weight: ${baseTheme.fontWeights.bold};
  padding: 10px 0px;
`
const SubmenuInnerCard = styled(Flex).attrs({
  alignItems: ['center'],
})`
  gap: 9px;
`

function MobileNavbar ({
  isContentFullWidth,
  menuObject,
  primaryCta,
  secondaryCta,
  hideSecondaryCta,
}) {
  const [isOpen, setIsOpen] = useState(false)
  const [openSubmenus, setOpenSubmenus] = useState(
    new Array(menuObject.length).fill(false)
  )
  function toggleSubMenu (index) {
    const newSubmenusState = [...openSubmenus]
    newSubmenusState[index] = !newSubmenusState[index]
    setOpenSubmenus(newSubmenusState)
  }

  function renderToggleButton () {
    return (
      <ToggleButtonContainer>
        <NavbarLinkStyled to="/">
          <Brand />
        </NavbarLinkStyled>
      </ToggleButtonContainer>
    )
  }

  function renderLeftButtons () {
    return (
      <NavbarLeftButtons>
        {isOpen ? (
          <IconClose onClick={() => setIsOpen(!isOpen)} />
        ) : (
          <IconNavMenu onClick={() => setIsOpen(!isOpen)} />
        )}
      </NavbarLeftButtons>
    )
  }

  function renderMenuItems () {
    return (
      <MenuItemContainer isOpen={isOpen}>
        {menuObject.map((menuItem, index) => (
          <MenuItemWrapper
            key={menuItem.title}
            onClick={() => toggleSubMenu(index)}
          >
            {menuItem.title === 'Pricing' ? (
              <ClickableMenu to={menuItem.to}>{menuItem.title}</ClickableMenu>
            ) : (
              <>
                <MenuItem>
                  {menuItem.title}
                  {menuItem.subMenu && (
                    <>
                      {openSubmenus[index] ? (
                        <IconChevronDown
                          height={10}
                          width={10}
                          fill={`${baseTheme.colors.blacks[30]}`}
                        />
                      ) : (
                        <IconChevronRight
                          height={10}
                          width={10}
                          fill={`${baseTheme.colors.blacks[30]}`}
                        />
                      )}
                    </>
                  )}
                </MenuItem>
                {renderSubMenu(menuItem, index)}
              </>
            )}
          </MenuItemWrapper>
        ))}
        <HeroButtonContainer>
          <Button
            type="black"
            chevron={{ position: 'inner', direction: 'right' }}
            to={primaryCta.to}
            size="large"
          >
            {primaryCta.text}
          </Button>
          <Button
            type="outline-default"
            chevron={{ position: 'inner', direction: 'right' }}
            to={secondaryCta.to}
            size="large"
          >
            {secondaryCta.text}
          </Button>
        </HeroButtonContainer>
      </MenuItemContainer>
    )
  }

  function renderSubMenu (menuItem, index) {
    return (
      <SubMenuContainer
        style={{
          display: openSubmenus[index] ? 'flex' : 'none',
        }}
      >
        {menuItem.subMenu &&
          menuItem?.subMenu?.map((subMenu, subIndex) => (
            <SubMenuItem key={subMenu.title}>
              <SubmenuCard to={subMenu.to}>
                <SubmenuInnerCard>
                  <IconWrapper bg={subMenu.bg}>{subMenu.icon}</IconWrapper>
                  <SubmenuInfo>
                    {subMenu.title}
                    <SubmenuDesc>{subMenu.desc}</SubmenuDesc>
                  </SubmenuInfo>
                </SubmenuInnerCard>
              </SubmenuCard>
            </SubMenuItem>
          ))}
      </SubMenuContainer>
    )
  }

  return (
    <NavbarContainer>
      {renderToggleButton()}
      {renderLeftButtons()}
      {renderMenuItems()}
    </NavbarContainer>
  )
}

export default MobileNavbar
